export enum PaypalIntentEnum {
  CAPTURE = 'CAPTURE',
  AUTHORIZE = 'AUTHORIZE'
}
